<template>
	<main>
		<section id="form">
            <div id="form-photo" class="interstitial">
			</div>
			<div id="form-content">
                <div class="container mb-5 flex-grow">
                    <Logo outerClass="py-4 py-sm-5" color="_dark" innerClass="logo" type="png" />

                     <div style="max-width: 770px;">
                        <h3 class="mb-5">{{formData.firstName || 'Sorry'}}, unfortunately we were unable to match you with a lender for your requested amount.</h3>
                        <div class="light mb-5">
                            <p>However, we work with several lenders who may approve you for a <strong>short term loan for up to $1000.</strong></p>
                            <p>Please note that loan amounts, interest rates and repayment terms will vary by lender.</p>
                            <p>If you would like to apply for a short term loan of up to $1000, please click the <strong>“continue”</strong> button below before your session expires.</p>
                            <p>Time left in your session: 
                                <strong class="text-danger" v-if="timer > 0">{{minutes}}:{{ (seconds < 10) ? `0${seconds}` : seconds }}</strong>
                                <strong class="text-danger" v-else>Out of time</strong>
                            </p>
                        </div>
                        <div class="my-5 d-flex align-items-center flex-wrap">
                            <button class="btn btn-cta btn-red uc" :disabled="saving" id="form-submit-declined" @click="submit">{{saving ? 'Sending Your Request...' : 'Continue'}}</button>
                            <div v-if="saving" class="mt-3 mt-md-0 ml-auto ml-md-3 mr-auto mr-md-0">
                                <div class="dots">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                            <div v-if="saving" class="mt-2 w-100">
                                <small>Please wait while we search our network of lenders. This process may take up to 5-8 minutes. DO NOT close your browser, refresh the page or press the back button as this will interfere with your submission.</small>
                            </div>
                            <div v-if="errorMessage" class="alert alert-danger w-100 mt-4">
                                There was an error submitting your application. Please try again later.
                            </div>
                        </div>
                     </div>
                </div>
                <Footer />
			</div>
		</section>
        <Loading v-if="saving" message="Please wait while we search our network of lenders. This process may take up to 5-8 minutes. DO NOT close your browser, refresh the page or press the back button as this will interfere with your submission." />
	</main>
</template>

<script>
// @ is an alias to /src
import Logo from '@/components/Logo.vue';
import Footer from '@/components/Footer.vue';
import Loading from '@/components/form/Loading.vue';
import { setInterval, clearInterval } from 'timers';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Interstitial',
  title: 'Re-Submit',
  components: {
    Logo,
    Footer,
    Loading
  },
  data(){
      return {
          errorMessage: false,
          saving: false,
          timer: 600000,
          minutes: 10,
          seconds: 0,
          exit: false,
      }
  },
  methods: {
      ...mapActions(['saveFormData', 'sendToAPI']),
      submit(){
          this.saving = true;
          this.saveFormData({
                'loan_amount' : "$500 - $1000",
                'loan_amount_raw': 800,
                'loan_amount_range': '500;1000'
            });
                    
            this.sendToAPI().then( response => {
                if(response){
                    location.replace(response);
                } else {
                    //There has been an error... show error
                    this.errorMessage = true;
                    this.saving = false;
                }
            }).catch( response => {
                //There has been an error show error
                this.saving = false;
                this.errorMessage = true;
            }).finally( () => {
                return;
            });
      }
        
  },
  computed: {
        ...mapGetters(["formData"]),
    },
  created(){
      let countDown = setInterval(() => {
          if(!this.exit){
            if(this.timer == 0){
                if(confirm('Do you want to extend your session?')){
                    this.timer = 600000;
                } else {
                    if(confirm('Are you sure? Hitting OK will close this session, hit Cancel to continue with your loan submission.')){
                        this.exit = true;
                    } else {
                        this.timer = 600000;
                    }
                }
            } else {
                this.timer -= 1000;
                this.minutes = Math.floor((this.timer % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = Math.floor((this.timer % (1000 * 60)) / 1000);
            }
          } else {
              clearInterval(countDown);
          }
          
      }, 1000);
  }
}
</script>